/**
 * The application version, recorded in every exported session and validation report.
 *
 * Read from the build rather than hard-coded, so an exported file always says which build produced
 * it — the first question when a result looks wrong.
 */
export const APP_VERSION: string = __APP_VERSION__;
